import { render, staticRenderFns } from "./alkene.vue?vue&type=template&id=ac0c8678&"
import script from "./alkene.vue?vue&type=script&lang=js&"
export * from "./alkene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports